// extracted by mini-css-extract-plugin
module.exports = {"betAction":"BetStake_betAction__jxMOC","earn":"BetStake_earn__ErVCC","earnAmount":"BetStake_earnAmount__3YZNo"};